var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-descriptions",
        { attrs: { column: 4 } },
        [
          _c("el-descriptions-item", { attrs: { label: "YS销售单号" } }, [
            _vm._v(" " + _vm._s(_vm.detail.cthirdOrderCode) + " "),
          ]),
          _c("el-descriptions-item", { attrs: { label: "出货日期" } }, [
            _vm._v(" " + _vm._s(_vm.detail.tout) + " "),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "客户名称" } },
            [
              _vm._l(_vm.channelOptions, function (item) {
                return [
                  _vm.detail.rchannel.includes(item.code)
                    ? [_vm._v(" " + _vm._s(item.name) + " ")]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c("el-descriptions-item", { attrs: { label: "门店编号" } }, [
            _vm._v(" " + _vm._s(_vm.detail.cstore) + " "),
          ]),
          _c("el-descriptions-item", { attrs: { label: "门店名称" } }, [
            _vm._v(" " + _vm._s(_vm.detail.sstore) + " "),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "财务关系" } },
            [
              _vm._l(_vm.financialOptions, function (item) {
                return [
                  _vm.detail.cfinance.includes(item.id)
                    ? [_vm._v(" " + _vm._s(item.name) + " ")]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c("el-descriptions-item", { attrs: { label: "同步状态" } }, [
            _vm.detail.bstatus === 1
              ? _c("div", { staticStyle: { color: "blue" } }, [
                  _vm._v(" 等待同步 "),
                ])
              : _vm.detail.bstatus === 3
              ? _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v(" 同步失败 "),
                ])
              : _c("div", { staticStyle: { color: "green" } }, [
                  _vm._v(" 同步成功 "),
                ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "同步时间" } }, [
            _vm._v(" " + _vm._s(_vm._f("time")(_vm.detail.tsync)) + " "),
          ]),
        ],
        1
      ),
      _c(
        "el-input",
        {
          staticClass: "search-input",
          attrs: {
            clearable: "",
            placeholder: "请输入关键字查询",
            size: "mini",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.handleSearch.apply(null, arguments)
            },
          },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c("el-button", {
            attrs: { slot: "append", icon: "el-icon-search" },
            on: { click: _vm.handleSearch },
            slot: "append",
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.detailList,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-text": _vm.loadingMsg,
            height: "calc(70vh - 200px)",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", align: "center", type: "index" },
          }),
          _c("el-table-column", {
            attrs: { label: "图片", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      staticClass: "w50 h50",
                      attrs: {
                        "preview-src-list": [scope.row.cmasterUrl],
                        src: scope.row.cmasterUrl,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "SKU", align: "center", prop: "csku" },
          }),
          _c("el-table-column", {
            attrs: { label: "条形码", align: "center", prop: "cbarcode" },
          }),
          _c("el-table-column", {
            attrs: { label: "货品名称", align: "center", prop: "sgoods" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "数量",
              align: "center",
              prop: "nout",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "单价",
              align: "center",
              prop: "nprice",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "金额",
              align: "center",
              prop: "namount",
              sortable: "",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "dialog-footer" }, [
        _c("span", [
          _vm._v("共计 " + _vm._s(_vm.detailList.length) + " 种货品"),
        ]),
        _c(
          "div",
          { staticClass: "dialog-footer-tail" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  plain: "",
                  loading: _vm.loading,
                  disabled:
                    _vm.detail.bstatus === 1 || _vm.detail.bstatus === 2,
                },
                on: { click: _vm.handleSync },
              },
              [
                _c("span", [_vm._v("同步到YS")]),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: { effect: "dark", placement: "top-start" },
                  },
                  [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _vm._v("若单据状态为同步失败，可再次推送，否则不能推送"),
                    ]),
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: { "margin-left": "5px" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.modalClose },
              },
              [_vm._v("关闭")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }